export default __webpack_public_path__ + "static/media/nft-op-4.beb5617f.svg";